<template>
  <div class="how-it-works-grid">
    <div class="how-it-works">
      <h1 class="how-it-works-heading">
        How HSF<span class="sup">&reg;</span> works
      </h1>
      <p class="how-it-works-text">
        HSF<span class="sup">&reg;</span> operates like a loan, with one monthly payment and a <b>0.00% APR*</b>.<br/>
 Joining the patient financing program is easy. Here is how it works: 
      </p>
    </div>
    <div class="steps-for-how-it-works-grid">
      <div class="text-image-grid">
        <div class="steps-for-how-it-works-text">
          Find your provider with our online lookup tool
        </div>
        <img class="image" alt="window edit image" src="@Shared/assets/images/Vector.png" />
      </div>
      <div class="chevron-margin">
        <img alt="window edit image" src="@Shared/assets/images/Chevron Right.png" />
      </div>
      <div class="text-image-grid">
        <div class="steps-for-how-it-works-text">
          Enroll in HSF<span class="sup">&reg;</span> through our website - no credit check required
        </div>
        <img class="image" alt="window edit image" src="@Shared/assets/images/window-edit1.png" />
      </div>
      <div class="chevron-margin">
        <img alt="window edit image" src="@Shared/assets/images/Chevron Right.png" />
      </div>
      <div class="text-image-grid">
        <div class="steps-for-how-it-works-text">
          Consolidate charges to a single monthly payment
        </div>
        <img class="image" alt="hand credit card image" src="@Shared/assets/images/hierarchy-structure.png" />
      </div>
      <div class="chevron-margin">
        <img alt="window edit image" src="@Shared/assets/images/Chevron Right.png" />
      </div>
      <div class="text-image-grid">
        <div class="steps-for-how-it-works-text">
          Easily access your account online
        </div>
        <img class="image" alt="hand credit card image" src="@Shared/assets/images/desktop.png" />
      </div>
      <div class="chevron-margin">
        <img alt="window edit image" src="@Shared/assets/images/Chevron Right.png" />
      </div>
      <div class="text-image-grid">
        <div class="steps-for-how-it-works-text">
          Make payments online, or set up AutoPay
        </div>
        <img class="image" alt="currency exchange image" src="@Shared/assets/images/send-money.png" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HowHSFandCMCWork",
};
</script>
<style lang="scss" scoped>
.chevron-formatting {
  column-width: 10px;
}

.how-it-works-grid {
  display: grid;
  grid-template-rows: repeat(3, auto);
  margin-left: 10vh;

  @media all and (max-width: $grid-breakpoint-lg) {
    margin-top: 30px;
    margin-left: 0;
  }

  .how-it-works-text {
    b {
      font-weight: 700;
    }
    @media all and (max-width: $grid-breakpoint-sm) {
      font-size: 16px;
    }
  }

  .steps-for-how-it-works-grid {
    display: grid;
    grid-template-rows: repeat(1, auto);
    grid-template-columns: repeat(9, auto);
    margin-top: 75px;
    margin-bottom: 100px;
    margin-right: 30px;

    @media all and (max-width: $grid-breakpoint-lg) {
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: repeat(9, auto);
      margin-right: 0;
      row-gap: 20px;
    }

    .text-image-grid {
      display: grid;
      grid-template-rows: 25% 75%;
      align-items: center;
      justify-content: center;
      row-gap: 30px;

      @media all and (max-width: $grid-breakpoint-lg) {
        display: grid;
        grid-template-columns: 25% auto;
        column-gap: 15px;
        align-items: normal;
        justify-content: unset;
        grid-template-rows: 0;
        row-gap: 0;
        column-gap: 15%;
      }

      .image {
        margin: auto;

        @media all and (max-width: $grid-breakpoint-lg) {
          grid-column: 1;
        }
      }
    }

    .chevron-margin {
      margin-top: auto;

      @media all and (max-width: $grid-breakpoint-lg) {
        margin-left: 9.5%;

        img {
          transform: rotate(90deg);
        }
      }

      @media all and (max-width: $grid-breakpoint-md) {
        margin-left: 6%;

        img {
          transform: rotate(90deg);
        }
      }
    }
  }
}

.sup {
  font-size: 60%;
  vertical-align: super;
}

.how-it-works {
  text-align: center;

  @media all and (max-width: $grid-breakpoint-md) {
    text-align: left;
  }

  .how-it-works-heading {
    font-weight: 500;
    margin-bottom: 10px;
    font-family: "Poppins";
    font-size: 28px;
    line-height: 42px;

    @media all and (max-width: $grid-breakpoint-md) {
      font-size: 20px;
    }
  }
}

.steps-for-how-it-works-text {
  text-align: center;
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0.02em;

  @media all and (max-width: $grid-breakpoint-lg) {
    font-family: Poppins;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0px;
    text-align: left;
    grid-column: 2;
  }
}


</style>
